export const API_BASE_URL = window.config.API_BASE_URL || 'http://localhost:8080'
export const DISABLE_APP_CONFIG_CACHE = window.config.DISABLE_APP_CONFIG_CACHE === 'true'
export const APP_CONFIG_CACHE_TTL_SECONDS = Number(window.config.APP_CONFIG_CACHE_TTL_SECONDS || 3600)
export const HIDE_KIR_DEV_IN_FOOTER = window.config.HIDE_KIR_DEV_IN_FOOTER === 'true'
export const CLIENT_BASE_URL = window.config.CLIENT_BASE_URL || 'http://localhost:3000'
export const OFFICIAL_LANGUAGE = window.config.OFFICIAL_LANGUAGE === 'true'
export const PASS_SERVER_URL = window.config.PASS_SERVER_URL || undefined
export const PASS_TEMPLATE = window.config.PASS_TEMPLATE || undefined
export const FIREBASE_PROJECT_ID = window.config.FIREBASE_PROJECT_ID || undefined
export const FIREBASE_APP_ID = window.config.FIREBASE_APP_ID || undefined
export const FIREBASE_API_KEY = window.config.FIREBASE_API_KEY || undefined
export const FIREBASE_SENDER_ID = window.config.FIREBASE_SENDER_ID || undefined
export const FIREBASE_WEB_PUSH_PUBLIC_KEY = window.config.FIREBASE_WEB_PUSH_PUBLIC_KEY || undefined
